import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as api from './api'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchAchievement(payload: { id: string }): SagaIterator {
  try {
    const achievement = yield effects.call(api.fetchAchievement, payload.id)
    yield effects.put(actions.fetchAchievementSuccess(achievement.data))
  } catch (error) {
    console.warn('Cannot fetch achievement', error)
    yield effects.put(
      actions.fetchAchievementFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* editAchievement(payload: {
  id: string
  status: string
  caption: string
  requirements: string
  description: string
  shareDescription: string
  image?: File
}): SagaIterator {
  try {
    const {
      id,
      status,
      caption,
      requirements,
      description,
      shareDescription,
      image,
    } = payload
    yield effects.call(
      api.editAchievement,
      id,
      status,
      caption,
      requirements,
      description,
      shareDescription,
      image
    )
    yield effects.put(actions.editAchievementSuccess())
    yield effects.put(actions.fetchAchievement(id))
  } catch (error) {
    console.warn('Cannot edit achievement', error)
    yield effects.put(actions.editAchievementFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* fetchUsersCount(): SagaIterator {
  try {
    const usersCount = yield effects.call(api.fetchUsersCount)
    yield effects.put(actions.fetchUsersCountSuccess(usersCount.users_count))
  } catch (error) {
    console.warn('Cannot fetch users count', error)
    yield effects.put(actions.fetchUsersCountFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchAchievement(): SagaIterator {
  yield effects.takeEvery(actions.fetchAchievement.toString(), fetchAchievement)
}

function* watchEditAchievement(): SagaIterator {
  yield effects.takeEvery(actions.editAchievement.toString(), editAchievement)
}

function* watchFetchUsersCount(): SagaIterator {
  yield effects.takeEvery(actions.fetchUsersCount.toString(), fetchUsersCount)
}

export default function* watchAdminAchievementEdit(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchAchievement),
    effects.fork(watchEditAchievement),
    effects.fork(watchFetchUsersCount),
  ])
}
